var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableLamp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78647 2C7.7671 2 6.89069 2.67848 6.69612 3.61826L5.03984 11.6183C4.78423 12.8529 5.79102 14 7.13019 14H11.2014V20.5H7.74099C7.29996 20.5 6.94243 20.8358 6.94243 21.25C6.94243 21.6642 7.29996 22 7.74099 22H16.259C16.7 22 17.0576 21.6642 17.0576 21.25C17.0576 20.8358 16.7 20.5 16.259 20.5H12.7986V14H16.8698C18.209 14 19.2158 12.8529 18.9602 11.6183L17.3039 3.61826C17.1093 2.67848 16.2329 2 15.2135 2H8.78647Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLamp1);
export default __webpack_public_path__ + "static/media/table-lamp-1.870af4402d639671def53ffa5af5ad85.svg";
export { ForwardRef as ReactComponent };